const API_BASE = "https://betfinity.azurewebsites.net";

export const HOME_PAGE_GAMES_API = `${API_BASE}/HomeContent`
export const GAMES_FILTERS_API = `${API_BASE}/GameFilter`
export const PLACE_BET_API = `${API_BASE}/Betting/placebet`